// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"41acd74a","69":"d255afe3","159":"d045c656","336":"b4e86458","453":"9d6d809d","689":"3e486aeb","722":"b1376add","743":"b80ceda5","962":"a978224c"}[chunkId] + ".chunk.js";
};